
const Today = (props: any) : JSX.Element => {
  return <></>
} 

export default Today